import { ReactNode, useRef } from 'react';

import { usePopupManager } from 'providers/PopupManagerProvider';
import { PopupOptions } from 'providers/popupTypes';

export const usePopup = () => {
  const { showPopup: showPopupByManager, hidePopup: hidePopupByManager, popups } = usePopupManager();
  const popupId = useRef<string | null>(null);

  const showPopup = (content: ReactNode, options: PopupOptions = {}) => {
    if (!popupId.current) {
      const onAfterHide = () => {
        popupId.current = null;
        options.onAfterHide?.();
      };

      popupId.current = showPopupByManager(content, { ...options, onAfterHide });
    }
  };

  const hidePopup = (hideAll = false) => {
    if (hideAll) popups.forEach(popup => hidePopupByManager(popup.id));
    if (popupId.current) {
      hidePopupByManager(popupId.current);
      popupId.current = null;
    }
  };

  return { showPopup, hidePopup };
};
